module.exports = __webpack_public_path__ + "assets/img/00048.3f802a36.png";